export const POLLING_INTERVAL = 10000;
